"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ImagePreloader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ImagePreloader, _Component);

  var _super = _createSuper(ImagePreloader);

  function ImagePreloader(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ImagePreloader);
    _this = _super.call(this, props);
    _this.state = {
      status: ImagePreloader.STATUS_PENDING
    };
    return _this;
  }

  (0, _createClass2.default)(ImagePreloader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        image: this.loadImage(this.props)
      });
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.src !== nextProps.src) {
        this.setState({
          status: ImagePreloader.STATUS_PENDING,
          image: this.loadImage(nextProps)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        willUnmount: true
      });
    }
  }, {
    key: "loadImage",
    value: function loadImage(_ref) {
      var _this2 = this;

      var src = _ref.src,
          isAnonymous = _ref.isAnonymous;
      var image = new Image();

      if (isAnonymous) {
        image.crossOrigin = 'Anonymous';
      } // pre-load the actual image


      image.src = src;

      image.onload = function () {
        return _this2.handleImageLoaded();
      };

      image.onerror = function () {
        return _this2.handleImageFailed();
      };

      return image;
    }
  }, {
    key: "handleImageLoaded",
    value: function handleImageLoaded() {
      if (this.state.willUnmount) {
        return;
      }

      this.setState({
        status: ImagePreloader.STATUS_LOADED
      });
      this.props.onLoaded(this.state.image);
    }
  }, {
    key: "handleImageFailed",
    value: function handleImageFailed() {
      if (this.state.willUnmount) {
        return;
      }

      this.setState({
        status: ImagePreloader.STATUS_FAILED
      });
      this.props.onFailed(this.state.image);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state);
    }
  }]);
  return ImagePreloader;
}(_react.Component);

ImagePreloader.STATUS_PENDING = 'PENDING';
ImagePreloader.STATUS_LOADED = 'LOADED';
ImagePreloader.STATUS_FAILED = 'FAILED';
ImagePreloader.defaultProps = {
  onLoaded: function onLoaded() {},
  onFailed: function onFailed() {},
  isAnonymous: false
};
ImagePreloader.propTypes = {
  src: _propTypes.default.string.isRequired,
  onLoaded: _propTypes.default.func,
  onFailed: _propTypes.default.func,
  isAnonymous: _propTypes.default.bool
};
var _default = ImagePreloader;
exports.default = _default;